
    const mBody = document.getElementsByTagName('body')[0]
    function scrollHeightCheck() {
        window.scrollY >= 100 ? mBody.classList.add('scrolled') 
                         : mBody.classList.remove('scrolled')
    }
    document.onscroll = function() { scrollHeightCheck() }
    scrollHeightCheck()


const videos = document.querySelectorAll('video[autoplay]')

var motionQuery = matchMedia('(prefers-reduced-motion: reduce)');

function handleReduceMotionChanged() {
  if(videos) {
     videos.forEach(function (video, index) {
    if (motionQuery.matches) {
        video.removeAttribute('autoplay')
        
      
    } else {
       
       
    }

    });    
   }

                    

}

motionQuery.addEventListener("change", handleReduceMotionChanged)

handleReduceMotionChanged(); // trigger once on load



document.addEventListener('DOMContentLoaded', function () {
  var isInProgress = false;

  window.addEventListener('scroll', function () {
    if (!isInProgress) {
      var footerTop = document.querySelector(".shopify-section-group-footer-group").getBoundingClientRect().top + window.pageYOffset;
      if ((window.pageYOffset + window.innerHeight) >= footerTop) {
        isInProgress = true;

        var loadMoreWrap = document.querySelector(".load-more_wrap");
        var totalPages = parseInt(loadMoreWrap.getAttribute("data-all-pages"));
        var currentPage = parseInt(loadMoreWrap.getAttribute("data-this-page"));
        var datacollurl = loadMoreWrap.getAttribute("data-coll-url");
        var next_coll = currentPage + 1;
        var nextUrl = datacollurl + "?page=" + next_coll;

        loadMoreWrap.setAttribute("data-this-page", next_coll);

        if (currentPage >= totalPages) return;

        fetch(nextUrl, {
          method: 'GET'
        })
        .then(response => response.text())
        .then(data => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data, 'text/html');
          var get_ul = doc.querySelector('.grid-uniform_js').innerHTML;
          document.querySelector(".grid-uniform_js").insertAdjacentHTML('beforeend', get_ul);
        })
        .finally(() => {
          isInProgress = false;
        });
      }
    }
  });
});